export default __webpack_public_path__ + "static/media/USDC-BUSD.f9711ee0.svg";